import axios from 'axios'

// const origin = process.env.NODE_ENV === 'production'
//   ? 'https://pr-tex.ru'
//   : 'http://localhost:8080'
const baseURL = process.env.NODE_ENV === 'production'
  ? 'https://pr-tex.ru/textile-print-calc/api/'
  : 'http://textile-print-calc/api/'

const instance = axios.create({
  baseURL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
})
instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// instance.defaults.headers.common['Access-Control-Allow-Origin'] = origin;
// instance.defaults.headers.common['Access-Control-Allow-Headers'] = "Origin, X-Requested-With, Content-Type, Accept";

export default instance